import React from 'react';

const SendArrowSvg = ({size = 48, color = 'black'}) => (
    <svg width={size} height={(size / 48) * 31} viewBox="0 0 38 30" fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path d="M10 16.122H31V14.622H10V16.122Z"
              fill={color}/>
        <path
            d="M4.01201 25.9146C3.78308 26.3223 4.1893 26.7932 4.62622 26.6265L32.7303 15.9049C33.1541 15.7433 33.1609 15.1461 32.7409 14.9748L4.40272 3.41583C3.97401 3.24096 3.5584 3.69247 3.76812 4.10527L8.85319 14.1145C9.38257 15.1565 9.35689 16.394 8.78474 17.4131L4.01201 25.9146Z"
            stroke={color}
            strokeWidth="4"/>
    </svg>
);

export default SendArrowSvg;